export default "__VITE_ASSET__711a379d__"